var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 901.8 184.8",
    style: {
      enableBackground: "new 0 0 901.8 184.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#415563;}\n\t.st2{fill:#47B8AC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 92.4,
    cy: 92.4,
    r: 86.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.3,44.5C121.7,25.9,95,20.4,71.6,28l25.2,25.2c2.4,2.4,2.4,6.3,0,8.7L66.3,92.4l26.1,26.1l30.5-30.5 c2.4-2.4,6.3-2.4,8.7,0l25.2,25.2C164.5,89.8,158.9,63.1,140.3,44.5z M101.5,94.2c-0.2,1.2-0.7,2.3-1.3,3.3 c-0.3,0.5-0.7,1-1.2,1.4c-0.5,0.5-0.9,0.8-1.5,1.2c-2.6,1.7-5.8,2-8.6,0.8c-1.1-0.5-2.1-1.1-3-2c-1.4-1.4-2.2-3-2.5-4.8 c-0.6-2.9,0.3-6,2.5-8.3c3.6-3.6,9.5-3.6,13.1,0c0.9,0.9,1.6,1.9,2,3c0.4,1.1,0.7,2.3,0.7,3.5C101.6,93,101.6,93.6,101.5,94.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,92.4C0,41.5,41.5,0,92.4,0c51,0,92.4,41.5,92.4,92.4s-41.5,92.4-92.4,92.4S0,143.4,0,92.4z M172.5,92.4 c0-44.2-35.9-80.1-80.1-80.1S12.3,48.3,12.3,92.4s35.9,80.1,80.1,80.1S172.5,136.6,172.5,92.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.8,131.6c-2.4,2.4-6.3,2.4-8.7,0L53.2,96.8c-2.4-2.4-2.4-6.3,0-8.7l30.5-30.5L59.4,33.2 c-5.3,3-10.4,6.7-14.9,11.3C18,71,18,113.9,44.5,140.4c26.5,26.4,69.4,26.4,95.9,0c4.5-4.5,8.3-9.6,11.2-14.9l-24.3-24.3 L96.8,131.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M639.4,66.6h-23.2l0,70.3h-22.9V66.6h-26.6l5.4-20.2h72.7L639.4,66.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M713.4,116.6V137h-64.1V46.4h63.6v20.2h-40.7v15.2h38.2v18.9h-38.2v15.9H713.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M901.8,46.4V137h-22.7v-35.5h-35.7V137h-22.9V46.4h22.9v34.8h35.7V46.4H901.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M790,102.1c-4,9.9-11.1,14.6-22.1,14.6c-13.9,0-23.9-9.7-23.9-25.1c0-15.1,10.1-25.2,24.1-25.2 c10.1,0,16.9,4.6,21.2,14l19.9-11.5c-8-14.7-21.5-23.9-41-23.9c-27.4,0-47.6,19.7-47.6,46.6c0,27.5,20.4,46.7,47.1,46.7 c20.1,0,34.6-9.6,42.2-24.7L790,102.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M364.8,109.9h-10.9V137h-22.9V46.4h35.5c23,0,36.8,12.1,36.8,31.6c0,12.6-6.4,22.2-17.1,27.5l19.2,31.5 h-26.6L364.8,109.9z M353.9,88.5h12.9c8.4,0,13.4-3.7,13.4-10.5c0-6.9-4.7-10.5-13.2-10.5h-13V88.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M523.6,66.6v17.5H562l-5.2,19.9h-33.2v33h-22.9V46.4h62.4l-5.4,20.2H523.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M300.5,102.1c-4,9.9-11.1,14.6-22.1,14.6c-13.9,0-23.9-9.7-23.9-25.1c0-15.1,10.1-25.2,24.1-25.2 c10.1,0,16.9,4.6,21.2,14l19.9-11.5c-8-14.7-21.5-23.9-41-23.9c-27.4,0-47.6,19.7-47.6,46.6c0,27.5,20.4,46.7,47.1,46.7 c20.1,0,34.6-9.6,42.2-24.7L300.5,102.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M470.3,46.4h-36.8L409.3,137l24.1,0l3.8-16.4h29.5l3.8,16.4l24.1,0L470.3,46.4z M441.8,100.7l0.9-3.8 l6.7-28.5l0.6-5l3.7,0l0.6,5l6.7,28.5l0.9,3.8H441.8z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c64ab0ad79850ebe08975f659d6c03a0.svg";
export { ForwardRef as ReactComponent };